module.exports = __webpack_public_path__ + "img/logo.d8b500c8.png";